import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullDealsTag on DealsTag {
    filterable
    name
    url
    uuid
    locale
  }
`

export default fragment
